import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "download",
  "use": "download-usage",
  "viewBox": "0 0 20 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 16\" id=\"download\"><defs><style>#download .cls-1{fill-rule:evenodd}</style></defs><path class=\"cls-1\" d=\"M10 0a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0V1a1 1 0 0 1 1-1zM1 14h18a1 1 0 1 1 0 2H1a1 1 0 1 1 0-2zm13.94-7.928a1 1 0 0 1 0 1.414l-4.24 4.243a1.002 1.002 0 0 1-1.42-1.414l4.25-4.243a1 1 0 0 1 1.41 0zm-9.64.207a.951.951 0 0 0 0 1.358l4.07 4.073a.961.961 0 0 0 1.36-1.358L6.65 6.279a.951.951 0 0 0-1.35 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/download.svg
// module id = UXgm
// module chunks = 6